import React, { Suspense, lazy, useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import AOS from "aos";
import Footer from "./Container/Footer";
import Navbar from "./Container/Navbar";
import WhatsappIcon from "./Assets/whatsapp.svg";

const Home = lazy(() => import("./Components/HomePage/HomePage"));
const Pricing = lazy(() => import("./Components/Pricing/Pricing"));
const ContactUs = lazy(() => import("./Components/ContactUs/ContactUs"));
const Services = lazy(() => import("./Components/Services/Services"));
const TermAndConditions = lazy(() =>
  import("./Components/Term&Conditions/TermAndConditions")
);

function App() {
  const [message, setMessage] = useState("");

  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <div className="App">
      <div className="fixed z-50 bottom-5 left-1 inline-block group">
        <div
          style={{
            width: "65px",
            height: "65px",
            borderRadius: "50px",
          }}
          className="fixed bottom-5 left-1 border-white/10 shadow-[0_0_30px_rgba(79,70,229,0.15)] bg-gradient-to-br from-gray-900/95 to-gray-800/95 backdrop-blur-md flex items-center justify-center animate-pulse animate-infinite"
        >
          <img
            style={{ width: "45px", height: "45px" }}
            src={WhatsappIcon}
          />
        </div>

        <div className="absolute invisible opacity-0 group-hover:visible group-hover:opacity-100 left-40 bottom-14 -translate-x-1/2 mb-3 w-72 transition-all duration-300 ease-out transform group-hover:translate-y-0 translate-y-2">
          <div className="relative p-4 bg-gradient-to-br from-gray-900/95 to-gray-800/95 backdrop-blur-md rounded-2xl border border-white/10 shadow-[0_0_30px_rgba(79,70,229,0.15)]">
            <div className="flex items-center gap-3 mb-2">
              <div className="flex items-center justify-center w-8 h-8 rounded-full bg-indigo-500/20">
                <svg
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  className="w-4 h-4 text-indigo-400"
                >
                  <path
                    clip-rule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                    fill-rule="evenodd"
                  ></path>
                </svg>
              </div>
              <h3 className="text-sm font-semibold text-white">
                Hello, how can we help you?
              </h3>
            </div>

            <div className="space-y-2 mt-4">
              <div id="input" className="relative">
                <textarea
                  type="text"
                  id="floating_outlined"
                  name="message"
                  className="block w-full text-sm px-4 py-3 text-slate-900 bg-white rounded-[8px] border border-violet-200 appearance-none focus:border-transparent focus:outline focus:outline-2 focus:outline-primary focus:ring-0 hover:border-brand-500-secondary- peer invalid:border-error-500 invalid:focus:border-error-500 overflow-ellipsis overflow-hidden text-nowrap pr-[48px]"
                  placeholder="Message"
                  value={message}
                  onChange={(e) => {
                    setMessage(e?.target?.value);
                  }}
                ></textarea>
                <label
                  for="floating_outlined"
                  className="peer-placeholder-shown:-z-10 peer-focus:z-10 absolute text-[14px] leading-[150%] text-primary peer-focus:text-primary peer-invalid:text-error-500 focus:invalid:text-error-500 duration-300 transform -translate-y-[1.2rem] scale-75 top-2 z-10 origin-[0] bg-slate-400 disabled:bg-gray-50-background- px-2 peer-focus:px-2 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-[1.2rem] rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                >
                  Message
                </label>
              </div>
              <div className="flex justify-end">
                <a
                  href={`https://api.whatsapp.com/send?phone=971508460229&text=${message}`}
                  className="mt-3 h-6 w-6"
                >
                  <svg
                    className="h-6 w-6 text-slate-500"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    {" "}
                    <line x1="22" y1="2" x2="11" y2="13" />{" "}
                    <polygon points="22 2 15 22 11 13 2 9 22 2" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <BrowserRouter basename={`/`}>
        <Suspense
          fallback={
            <div className="d-flex justify-content-center">loading.....</div>
          }
        >
          <Navbar />
          <Routes>
            <Route path={`/`} element={<Home />} />
            <Route path={`/pricing`} element={<Pricing />} />
            <Route path={`/services`} element={<Services />} />
            <Route path={`/contact_us`} element={<ContactUs />} />
            <Route
              path={`/term_and_condition`}
              element={<TermAndConditions />}
            />
          </Routes>
          <Footer />
        </Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;
